import { render, staticRenderFns } from "./PagesConfig.vue?vue&type=template&id=96f67314&scoped=true&"
import script from "./PagesConfig.vue?vue&type=script&lang=js&"
export * from "./PagesConfig.vue?vue&type=script&lang=js&"
import style0 from "./PagesConfig.vue?vue&type=style&index=0&id=96f67314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f67314",
  null
  
)

export default component.exports